import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from "react-toastify";
import TapIcon from "../../../services/TapIcon";
import { EMP_WORKLOG_URL, HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import DateService from "../../../services/DateService";
import Status from "../../../components/ui/Status";
import Loader from "../../../components/ui/Loader/Loader";
import WorklogDocument from "../worklog/WorklogDocument";
import { Link } from "react-router-dom/cjs/react-router-dom";
import TicketDetailModal from "../../transactions/ticketTransaction/TicketDetailModal";

const WorkLogDetailModal = forwardRef((props, ref) => {
    const access_token = useSelector(state => state.auth.access_token);
    const modalElem = useRef(null);
    const searchModal = useRef(null);
    const ticketDetailRef = useRef(null)
    const modalID = uuid();
    const [attendenceData, setAttendenceData] = useState(null)
    const [employeeData, setEmployeeData] = useState(null)
    const [loading, setLoading] = useState(false);
    const [worklogDetails, setWorklogDetails] = useState([]);


    useEffect(() => {
        modalElem.current = document.getElementById(modalID);
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);

    useImperativeHandle(ref, () => ({
        viewWorkLogDetailModalInit: (employeeData, attendenceData) => {
            setAttendenceData(attendenceData)
            setEmployeeData(employeeData)
            if (attendenceData?.id) {
                loadWorkLogDetails(attendenceData?.id)
            }
            openModalHandle();
        }
    }));

    const searchModalOpen = () => searchModal.current && searchModal.current.show();
    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
    };

    const openModalHandle = () => {
        searchModalOpen();
    };
    const loadWorkLogDetails = (id) => {
        setLoading(true);
        HttpAPICall.withAthorization("GET", `${EMP_WORKLOG_URL}/detail/${id}`,
            access_token, {}, {}, (resp) => {
                const respData = resp?.data;
                setWorklogDetails(respData || "");  
            }
        ).then(() => {
            setLoading(false);
        });
    };
    const formatDuration = (seconds) => {
    if (!seconds || seconds <= 0) return "-";

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hrs}h ${mins}m ${secs}s`;
};
    const getTicketDetail = (id) => {
        ticketDetailRef.current.ticketModalInit(id)
    }

    return (
        <>
        <div className="modal fade" id={modalID} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="hrmsactivationModalLabel">  <span>View WorkLog for : </span>{attendenceData?.start_time && DateService.dateTimeFormat(attendenceData?.start_time)} </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            onClick={searchModalClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className='p-1 bg-light border-bottom'>
                        <table className='table table-sm mb-0 table-borderless text-sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: "25%" }}> Employee Name (Code)   </td>
                                    <th>{employeeData ? `${employeeData.display_full_name}` : "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Status   </td>
                                    <th>{employeeData?.status && <Status color={employeeData.status_color_code}> {employeeData.status_text} </Status>}</th>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="modal-body">
                        {loading ? <Loader />
                            : <>
                                <div className="tab_content_wrapper"> <span className="content_heading">Worklog Detail</span></div>
                                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                    {worklogDetails && <tbody>
                                        <tr>
                                            <td style={{ width: "25%" }}>Start Time</td>
                                            <th>{worklogDetails?.start_time && DateService.dateTimeFormat(worklogDetails?.start_time)}</th>
                                        </tr>
                                         <tr>
                                            <td style={{ width: "25%" }}>End Time</td>
                                            <th>{worklogDetails?.end_time && DateService.dateTimeFormat(worklogDetails?.end_time)}</th>
                                        </tr>
                                         <tr>
                                            <td style={{ width: "25%" }}>Worklog Type</td>
                                            <th>{worklogDetails?.work_log_type && worklogDetails?.work_log_type?.name}</th>
                                        </tr>
                                          <tr>
                                            <td style={{ width: "25%" }}>Log Seconds</td>
                                            <th>{worklogDetails?.log_seconds && worklogDetails?.log_seconds}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Duration</td>
                                            <th>{formatDuration(worklogDetails?.log_seconds)}</th>
                                        </tr>
                                        
                                         {worklogDetails?.ticket &&  <><tr>
                                            <td style={{ width: "25%" }}>Ticket </td>
                                            <th>{worklogDetails.ticket ? <Status color={worklogDetails.ticket.status_color_code}> <Link onClick={() => getTicketDetail(worklogDetails.ticket.activity_id)}>{worklogDetails.ticket.activity_id} : {worklogDetails.ticket.header}</Link> </Status> : "-"}</th>
                                        </tr>
                                        </>}
                                         {/* <td colSpan={2} >{indent.ticket ? <Status color={indent.ticket.status_color_code}> <Link onClick={() => this.getTicketDetail(indent.ticket.activity_id)}>{indent.ticket.activity_id} : {indent.ticket.header}</Link> </Status> : "-"}</td> */}
                                        {worklogDetails?.ticket &&  <><tr>
                                            <td style={{ width: "25%" }}>Ticket Type</td>
                                            <th>{worklogDetails?.ticket && worklogDetails?.ticket?.ticket_type_name}</th>
                                        </tr>
                                        </>}
                                        {worklogDetails?.asset &&  <tr>
                                            <td style={{ width: "25%" }}>Asset</td>
                                            <th>{worklogDetails?.asset && worklogDetails?.asset?.name} ({worklogDetails?.asset && worklogDetails?.asset?.asset_code})</th>
                                        </tr>}
                                        {worklogDetails?.workstation && <tr>
                                            <td style={{ width: "25%" }}>WorkStation</td>
                                            <th>{worklogDetails?.workstation?.workstation_name && worklogDetails?.workstation?.workstation_name} ({worklogDetails?.workstation && worklogDetails?.workstation?.code || "-"})</th>
                                        </tr>}
                                        <tr>
                                            <td style={{ width: "25%" }}>Remarks</td>
                                            <th style={{
                                                wordBreak: "break-word",
                                                whiteSpace: "pre-wrap",
                                                overflowWrap: "break-word"
                                            }} >{worklogDetails.notes ? worklogDetails.notes : ''} </th>
                                        </tr>
                                    </tbody>}
                                </table>
                                <div className="tab_content_wrapper"> <span className="content_heading">Additional Attributes</span></div>
                                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                    {worklogDetails && <tbody>
                                        {worklogDetails.additional_attr && worklogDetails.additional_attr.length > 0 ?
                                            worklogDetails.additional_attr.map((attribute, index) => {
                                                return (<tr>
                                                    <td style={{ width: "25%" }}>{attribute.name}</td>
                                                    <th style={{
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                        overflowWrap: "break-word"
                                                    }} >{attribute.value ? attribute.value : "-"}</th>
                                                </tr>)
                                            })
                                            : null}
                                    </tbody>}
                                </table>
                                <WorklogDocument worklogDetails={worklogDetails} loadWorklogDetail={(id) => loadWorkLogDetails(id)} />
                            </>}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            onClick={searchModalClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <TicketDetailModal ref={ticketDetailRef} />
        </>
    );
});

export default WorkLogDetailModal;